import { debounce } from "lodash";
import React, { useState } from "react";
import { Autocomplete } from "../autocomplete/Autocomplete";

interface Props {
  updateSearchDelivery: (newSearchLoad: string) => void;
  sx?: React.CSSProperties;
}

export const SearchDeliveryTextField: React.FC<Props> = ({
  updateSearchDelivery,
  sx,
}) => {
  const [searchKeyword, setSearchKeyword] = useState<string>();

  const onChangeSearchTextField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keyword = event.currentTarget.value;
    debounceSearchKeyword(keyword);
  };

  const debounceSearchKeyword = debounce(
    async (searchDeliveryKeyword: string) => {
      updateSearchDelivery(searchDeliveryKeyword);
    },
    300
  );

  return (
    <Autocomplete
      width="383px"
      placeholder="상호명 또는 주소로 물류 검색"
      candidateMap={{}}
      value={searchKeyword}
      onChangeTextField={onChangeSearchTextField}
      onClickSelectItem={() => {}}
    />
  );
};
